import axios from 'axios'
import { DEFAULT_AXIOS_OPTIONS } from '../../../axios'
import { authRequestInterceptor } from '@/utils'

/**
 * API client for team-related operations following Feature Sliced Design principles.
 * Scoped within the team entity layer to:
 * 1. Encapsulate team-specific API configuration and interceptors
 * 2. Co-locate data fetching with the team domain model
 * 3. Enable independent evolution of team-related API logic
 * 4. Reduce coupling between different domain features
 * 5. Maintain clear boundaries in the codebase
 *
 * The client is configured with:
 * - Base URL from environment variables for team endpoints
 * - Default timeout and other axios options
 * - Authentication interceptor for protected routes
 *
 * @see https://feature-sliced.github.io/documentation/docs/reference/layers#entities
 */
const teamApi = axios.create({
  ...DEFAULT_AXIOS_OPTIONS,
  baseURL: import.meta.env.VITE_TEAM_FUNCTION_BASE,
})

teamApi.interceptors.request.use(authRequestInterceptor)

export { teamApi }
